export default __webpack_public_path__ + "fd818d62d1894f10ae502f8956c503ac.svg";